shvenergy.headerarea = (function ($) {
	"use strict";

	function init() {
		$(".header-area__arrow button").click(function (event) {
			$('html, body').animate({ scrollTop: '+=700px' }, 800);
		});

		$(".header-area .hero a.button").on("click", () => {
			trackBannerClick();
		});

		$(".header-area .hero a.button").on("auxclick", () => {
			trackBannerClick();
		});

		function trackBannerClick() {
			let bannerName = $(".header-area .hero__headline").first()[0].innerText,
				pageName = document.pageType == "Content page" ? document.title : document.pageType;

			bannerName = bannerName.replace("\n", "");

			shvenergy.tracking.trackRawEventData({
				'event':'clickBanner',
				'bannerName': bannerName,
				'pagename': pageName
			});
		}

		$(window).on("load", function () {
			let ogTitle = document.querySelector("[property='og:title']");
			let ogDescription = document.querySelector("[property='og:description']");
			let pageTypeCheck = document.querySelector("[pagetype-check]");
			let h1Element = document.querySelector('h1');
			let pagesInclude = ['newspage', 'blogpage'];
			const heroId = document.getElementById("hero");
			const scriptTag = heroId ? heroId.querySelector('script[type="application/ld+json"]') : heroId;

			if (ogTitle && !ogTitle.content.trim() && h1Element) {
				ogTitle.content = h1Element.innerText.trim();
			}
			if (pageTypeCheck && pagesInclude.includes(pageTypeCheck.getAttribute("pagetype-check")) && ogDescription && !ogDescription.content.trim() && h1Element) {
				ogDescription.content = h1Element.innerText.trim();
			}
			if (scriptTag && h1Element) {
				const jsonData = JSON.parse(scriptTag.textContent);
				if (!jsonData['@graph'][0].name) {
					jsonData['@graph'][0].name = h1Element.innerText.trim();
					scriptTag.textContent = JSON.stringify(jsonData, null, 2);	
				}
			}
		});
	}

	init();

})(jQuery);